<template>
  <img
    src="@/assets/facebook.png"
    alt=""
  >
</template>
